/** ShadowCams the native C++ / WebCodecs IPC path may bind (policy B: 00–08). */
export const NATIVE_VIDEO_CAMERAS = Object.freeze([
  'ShadowCam00', 'ShadowCam01', 'ShadowCam02', 'ShadowCam03',
  'ShadowCam04', 'ShadowCam05', 'ShadowCam06', 'ShadowCam07', 'ShadowCam08',
] as const);

export type NativeVideoCamera = (typeof NATIVE_VIDEO_CAMERAS)[number];

const ALLOWED = new Set<string>(NATIVE_VIDEO_CAMERAS);

export function isNativeVideoCamera(name: string): name is NativeVideoCamera {
  return ALLOWED.has(name);
}

/** Throws when `name` is not a product native camera (e.g. ShadowCam09). */
export function assertNativeVideoCamera(name: string): asserts name is NativeVideoCamera {
  if (!isNativeVideoCamera(name)) throw new Error(`camera-not-allowed: ${name}`);
}
